import services from '@/http';
import { user } from '@/http';

export const PORTO_ACCESS_LOG_VIEWED_OFFERS = 231;

const recentLogKeys = new Map();
const DEDUP_MS = 60000;

function sanitizeDocNumber(docNumber) {
  if (docNumber == null || docNumber === '') return null;
  const digits = String(docNumber).replace(/\D/g, '');
  if (digits.length < 11) return null;
  return digits;
}

/** Resolve o documento do devedor a partir das fontes disponíveis no fluxo autenticado. */
export function resolveDebtorDocNumber({ docNumber, user, contacts } = {}) {
  const candidates = [
    docNumber,
    user && user.DocNumber,
    contacts && contacts.DocNumber,
  ];

  for (const candidate of candidates) {
    const sanitized = sanitizeDocNumber(candidate);
    if (sanitized) return sanitized;
  }

  return null;
}

function resolveCredorCode(credor) {
  if (credor == null || credor === '') return null;
  return String(credor);
}

/** Persiste o credor escolhido no dashboard para o restante do fluxo do devedor. */
export function persistSelectedCredor(credor) {
  if (credor == null || credor === '') return;
  localStorage.setItem('credor', JSON.stringify(credor));
}

export function getSelectedCredor() {
  try {
    const stored = localStorage.getItem('credor');
    return stored != null ? JSON.parse(stored) : null;
  } catch (error) {
    return null;
  }
}

/**
 * Credores cujo log "Visualizou Ofertas" deve ser disparado no clique em Negociar (dashboard).
 * Nos demais, a API registra ao carregar ofertas na tela de propostas (evita duplicidade).
 */
export function shouldLogViewedOffersOnDashboardNegotiate(credor) {
  if (credor == null || credor === '') return false;
  if (String(credor).toUpperCase() === 'CONSORCI') return true;
  return Number(credor) === 5;
}

/**
 * Marca o log "Visualizou Ofertas" (ValueID 231) ao avançar para a tela de negociação.
 */
export async function markPortoViewedOffersLog({
  offerInfo,
  userAdm = null,
  ipUser = null,
  docNumber = null,
  debtorUser = null,
  contacts = null,
}) {
  if (!offerInfo) return;

  const credor = offerInfo.credor;
  const contract = offerInfo.contract;
  if (credor == null || contract == null) return;

  const credorCode = resolveCredorCode(credor);
  const debtorDocNumber = resolveDebtorDocNumber({ docNumber, user: debtorUser, contacts });
  const debtorId = (debtorUser && debtorUser.DebtorID) || (contacts && contacts.DebtorID) || null;

  const dedupKey = `${credorCode}|${contract}|${PORTO_ACCESS_LOG_VIEWED_OFFERS}`;
  const lastSent = recentLogKeys.get(dedupKey);
  if (lastSent && Date.now() - lastSent < DEDUP_MS) return;

  const notesJson = JSON.stringify({
    contrato: contract,
    credor: credorCode,
    produto: offerInfo.product || null,
    docNumber: debtorDocNumber,
  });

  const tag = localStorage.getItem('tag') || 'Padrao';

  user.sendLogAccess.data = {
    ValueId: PORTO_ACCESS_LOG_VIEWED_OFFERS,
    ValueID: PORTO_ACCESS_LOG_VIEWED_OFFERS,
    NotesJson: notesJson,
    Credor: credorCode,
    credorCode: credorCode,
    DocNumber: debtorDocNumber,
    DebtorID: debtorId,
    tag: tag.length > 100 ? tag.substring(0, 100) : tag,
    IP: ipUser || '',
    OS: (navigator.platform || '').substring(0, 50),
    UserID: userAdm && userAdm.UserID ? userAdm.UserID : null,
  };

  try {
    await services.http.request(user.sendLogAccess);
    recentLogKeys.set(dedupKey, Date.now());
  } catch (error) {
    console.warn('[LOG] Falha ao marcar Visualizou Ofertas Porto:', error);
  }
}
